<template>
  <div id="app">
    <div id="panel"><control-panel /></div>
    <div id="map"><google-map /></div>
    <div id="callout"><callout /></div>
  </div>
</template>

<script>
import ControlPanel from "@/components/control-panel.vue";
import GoogleMap from "@/components/google-map.vue";
import Callout from "@/components/callout.vue";

export default {
  name: "App",

  components: {
    ControlPanel,
    GoogleMap,
    Callout
  }
};
</script>

<style lang="scss">
#app {
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  position: relative;
  width: 100vw;
  height: 100vh;


  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-areas: "panel map";
}

#map {
  grid-area: map;
}

#panel {
  grid-area: panel;
}

#callout {
  width: 75vw;
  height: 100vh;
  position: fixed;
  left: 25vw;
  top: 0;
  pointer-events: none;
  overflow: hidden;
  box-shadow: inset 1px 0 2px rgba(#000, 0.15);
}

</style>
